<template>
  <page-layout class="market_article">

    <article class="inner" id="feed_results">

      <!-- 컨테이너 1 -->
      <div class="insta_ctnr" v-for="feed in getFeeds" :key="feed.idx" :ref="`feed_${feed.idx}`">
        <div class="logo">
          <span><img src="/statics/img/bi_origin.png"></span>
          <p>bluffandcatch</p>
        </div>
        <div class="img"><img v-if="isFileExist(feed.feed_img)" :src="getFileExist(feed.feed_img)" /></div>
        <div class="article">
          <p class="subj">{{ feed.title }}</p>
          <p class="con" v-html="feed.contents"></p>
          <p class="tag" v-if="feed.tags">
            <i>TAGs</i>
            <router-link :to="`/article/tag/${tag}`" v-for="(tag, i) in feed.tags" :key="i">{{tag}}</router-link>
          </p>
        </div>
      </div>

    </article>

  </page-layout>
</template>

<script>
	import Vue from 'vue'
  import { QDialog, Loading } from 'quasar'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import PageLayout from '../layouts/PageLayout'
  import { mapGetters } from 'vuex'
  const VueScrollTo = require('vue-scrollto')
  const baseAction = '/feeds'
  export default {
    name: "MarketArticle",
    components: {
      SubPageLayout,
      PageLayout,
      DisplayContainer,
      QDialog,
      Loading
    },
    metaInfo () {
      return {
        title: `${this.getAppName} | ${this.getFeedTitle}`,
        titleTemplate: '%s',
        meta: [
          {vmid: 'description', name: 'description', content: `Poker Market infographics`},
          {vmid: 'image', name: 'image', content: `${this.getFeedImg}`},
          {vmid: 'og:title', property: 'og:title', content: `${this.getFeedTitle} | ${this.getAppName}`},
          {vmid: 'og:description', property: 'og:description', content: `Poker Market infographics`},
          {vmid: 'og:image', property: 'og:image', content: `${this.getFeedImg}`}
        ]
      }
    },
    data () {
      return {
        baseAction: baseAction,
        selectedFeed: null,
      }
    },
    created () {
      if (!this.isExistFeedData) {
        this.$store.dispatch('callFeeds')
      }
    },
    activated () {
      if (this.isMobile) {
        setTimeout(() => {
          this.selectedFeed = this.getFeeds.find(row => row.idx === this.getRouteParamsIdx)
          if (!this.selectedFeed) {
            this.$router.replace('/market')
            return false
          }

          this.scrollToFeedRow()
        }, 500)
      } else {
        this.$router.replace(`/market?idx=${this.getRouteParamsIdx}`)
      }
    },
    computed: {
      ...CommonComputed,
      ...mapGetters([
        'getFeeds',
        'isExistFeedData',
      ]),
      getAccess () {
        return 'pc'
      },
      isMobile () {
        return this.getAccess === 'mobile'
      },
      getRouteParamsIdx () {
        return Number(this.$route.params.idx)
      },
      getFeedTitle () {
        return this.isExistFeedData && this.selectedFeed && this.selectedFeed.title ? this.selectedFeed.title : 'Poker Market infographics'
      },
      getFeedImg () {
        return this.isExistFeedData && this.selectedFeed && this.selectedFeed.feed_img && this.selectedFeed.feed_img.url ? this.selectedFeed.feed_img.url : '/statics/seo/seo_main.jpg'
      }
    },
		methods: {
      ...CommonMethods,
      scrollToFeedRow () {
        if (this.isExistFeedData && this.getRouteParamsIdx) {
          const el = this.$refs[`feed_${this.getRouteParamsIdx}`][0]
          const duration = 600
          VueScrollTo.scrollTo(el, duration, {offset: this.isMobile ? -60 : -159})
        }
      },
    }
  }
</script>

<style scoped>

</style>
